<template>
  <div class="nxp-diversity-banner">
    <div
      class="nxp-diversity-banner__icon-wrap"
      :class="hasDiversity ? 'nxp-diversity-banner__icon-wrap--filled' : 'nxp-diversity-banner__icon-wrap--empty'"
      aria-hidden="true"
    >
      <svg
        class="nxp-diversity-banner__icon"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 17 16"
        fill="none"
      >
        <g clip-path="url(#clip_diversity_banner)">
          <path
            d="M6.22614 15.0932C5.65075 15.0932 5.13205 14.9348 4.67006 14.6181C4.20819 14.3014 3.88411 13.8867 3.69782 13.374C3.55302 13.5491 3.36697 13.6854 3.13969 13.7827C2.91241 13.8799 2.66181 13.9285 2.3879 13.9285C1.83193 13.9285 1.35729 13.7362 0.963982 13.3517C0.570676 12.9671 0.374023 12.5001 0.374023 11.9506C0.374023 11.52 0.504986 11.1256 0.76691 10.7675C1.02871 10.4092 1.37587 10.1719 1.80837 10.0558C1.60363 9.82525 1.44366 9.56776 1.32846 9.2833C1.21314 8.99884 1.15548 8.71552 1.15548 8.43333C1.15548 7.88623 1.28968 7.39948 1.55808 6.97309C1.82635 6.54682 2.20719 6.21705 2.70059 5.98377C2.73488 6.20458 2.77042 6.38565 2.80722 6.52698C2.84402 6.66831 2.89191 6.79016 2.95089 6.89254C2.67146 7.05484 2.45821 7.26175 2.31112 7.51324C2.16404 7.76486 2.0905 8.04159 2.0905 8.34343C2.0905 8.88382 2.29728 9.33083 2.71084 9.68446C3.12441 10.0381 3.70789 10.2495 4.4613 10.3186L4.78496 10.9106C4.6531 11.2103 4.55762 11.4759 4.49852 11.7073C4.43954 11.9387 4.41005 12.1406 4.41005 12.3131C4.41005 12.8368 4.57968 13.2741 4.91892 13.625C5.25804 13.9759 5.68551 14.1513 6.20133 14.1513C6.55268 14.1513 6.86711 14.0522 7.14461 13.8539C7.42212 13.6556 7.67937 13.3435 7.91636 12.9176C8.15335 12.4916 8.37122 11.9351 8.56997 11.2481C8.76872 10.5611 8.96262 9.71826 9.15166 8.71959L10.0464 8.95335C9.87126 10.0359 9.66244 10.9657 9.41994 11.7426C9.17743 12.5195 8.89825 13.1555 8.58238 13.6505C8.26651 14.1457 7.91402 14.51 7.52491 14.7432C7.1358 14.9765 6.70288 15.0932 6.22614 15.0932ZM2.36992 12.9757C2.65582 12.9757 2.90114 12.8733 3.10589 12.6686C3.31051 12.4638 3.41282 12.2185 3.41282 11.9326C3.41282 11.6468 3.31051 11.4046 3.10589 11.2058C2.90114 11.0071 2.65582 10.9077 2.36992 10.9077C2.08414 10.9077 1.83888 11.0071 1.63414 11.2058C1.42939 11.4046 1.32702 11.6468 1.32702 11.9326C1.32702 12.2185 1.42939 12.4638 1.63414 12.6686C1.83888 12.8733 2.08414 12.9757 2.36992 12.9757ZM7.2 10.5218C6.513 9.93817 5.93227 9.40911 5.45781 8.93465C4.98335 8.46031 4.60083 8.02558 4.31026 7.63048C4.01957 7.23537 3.80931 6.86119 3.67948 6.50792C3.54966 6.15477 3.48475 5.80762 3.48475 5.46646C3.48475 4.72588 3.73415 4.0912 4.23294 3.56244C4.73174 3.03368 5.33344 2.7693 6.03806 2.7693C6.13947 2.7693 6.23447 2.77463 6.32306 2.7853C6.41153 2.79585 6.49724 2.81401 6.58019 2.83978C6.55166 2.76055 6.53212 2.68269 6.52157 2.60621C6.5109 2.52985 6.50557 2.45049 6.50557 2.36814C6.50557 1.81876 6.69779 1.35479 7.08222 0.976225C7.46666 0.597544 7.93344 0.408203 8.48259 0.408203C9.04383 0.408203 9.51392 0.597544 9.89284 0.976225C10.2719 1.35479 10.4614 1.82475 10.4614 2.38612C10.4614 2.47003 10.4561 2.55095 10.4454 2.62887C10.4348 2.70678 10.4153 2.77943 10.3868 2.8468C10.4697 2.82102 10.5465 2.80166 10.6169 2.78872C10.6875 2.77577 10.7795 2.7693 10.8929 2.7693C11.4766 2.7693 12.002 2.953 12.469 3.32042C12.936 3.68795 13.2433 4.15666 13.3909 4.72654C13.2145 4.68782 13.0476 4.66846 12.8901 4.66846C12.7325 4.66846 12.5675 4.69009 12.3951 4.73337C12.2402 4.40971 12.0145 4.15732 11.7179 3.97619C11.4215 3.79494 11.0996 3.70431 10.7522 3.70431C10.4366 3.70431 10.1359 3.79374 9.85005 3.97259C9.56415 4.15156 9.22478 4.49368 8.83196 4.99895H8.15299C7.80812 4.5342 7.48374 4.20227 7.17986 4.00316C6.87598 3.80393 6.54333 3.70431 6.18191 3.70431C5.6746 3.70431 5.25409 3.87417 4.92036 4.2139C4.58663 4.55362 4.41976 4.98313 4.41976 5.50242C4.41976 5.74361 4.47023 5.99085 4.57116 6.24414C4.67222 6.49755 4.85077 6.78908 5.10682 7.11874C5.36299 7.44839 5.71338 7.83199 6.15799 8.26953C6.60273 8.70707 7.17039 9.23751 7.86098 9.86085L7.2 10.5218ZM8.48349 3.42902C8.76938 3.42902 9.01465 3.32671 9.21927 3.12209C9.42401 2.91734 9.52639 2.67202 9.52639 2.38612C9.52639 2.10034 9.42401 1.85508 9.21927 1.65034C9.01465 1.44559 8.76938 1.34322 8.48349 1.34322C8.19759 1.34322 7.95232 1.44559 7.7477 1.65034C7.54295 1.85508 7.44058 2.10034 7.44058 2.38612C7.44058 2.67202 7.54295 2.91734 7.7477 3.12209C7.95232 3.32671 8.19759 3.42902 8.48349 3.42902ZM10.9068 15.1182C10.6057 15.1182 10.3041 15.0671 10.002 14.965C9.69978 14.8627 9.42599 14.7169 9.18061 14.5275C9.3398 14.2926 9.45105 14.116 9.51434 13.9976C9.57763 13.8791 9.62588 13.7653 9.65909 13.6561C9.82631 13.8042 10.0204 13.9249 10.2415 14.0183C10.4625 14.1116 10.6866 14.1583 10.9136 14.1583C11.3747 14.1583 11.7615 13.9951 12.0741 13.6685C12.3868 13.3421 12.5431 12.9285 12.5431 12.4278C12.5431 12.2375 12.5136 12.0262 12.4546 11.794C12.3955 11.5619 12.3 11.2721 12.1682 10.9244L12.4988 10.3505C13.2281 10.2933 13.8056 10.0807 14.2311 9.71269C14.6567 9.34479 14.8695 8.89065 14.8695 8.35026C14.8695 7.80807 14.6759 7.383 14.2887 7.07504C13.9014 6.76709 13.361 6.61311 12.6675 6.61311C12.246 6.61311 11.7123 6.69307 11.0665 6.85298C10.4206 7.01301 9.54808 7.2862 8.44896 7.67255L8.19723 6.75965C9.30462 6.35856 10.1911 6.07272 10.8566 5.90214C11.522 5.73156 12.1095 5.64627 12.6191 5.64627C13.5394 5.64627 14.3004 5.89986 14.902 6.40705C15.5037 6.91423 15.8045 7.56197 15.8045 8.35026C15.8045 8.67848 15.748 8.98781 15.6351 9.27826C15.5222 9.56884 15.3573 9.834 15.1406 10.0737C15.5731 10.1826 15.9203 10.4078 16.1821 10.7495C16.444 11.0911 16.575 11.4855 16.575 11.9326C16.575 12.4887 16.3813 12.9634 15.994 13.3567C15.6067 13.7499 15.141 13.9465 14.597 13.9465C14.3351 13.9465 14.0905 13.9009 13.8632 13.8097C13.636 13.7183 13.4319 13.5791 13.2512 13.392C13.1488 13.9047 12.8823 14.3205 12.4517 14.6395C12.0211 14.9586 11.5062 15.1182 10.9068 15.1182ZM14.597 12.9757C14.8828 12.9757 15.1281 12.8733 15.3328 12.6686C15.5376 12.4638 15.6399 12.2185 15.6399 11.9326C15.6399 11.6468 15.5376 11.4046 15.3328 11.2058C15.1281 11.0071 14.8828 10.9077 14.597 10.9077C14.3111 10.9077 14.0658 11.0071 13.8611 11.2058C13.6565 11.4046 13.5541 11.6468 13.5541 11.9326C13.5541 12.2185 13.6565 12.4638 13.8611 12.6686C14.0658 12.8733 14.3111 12.9757 14.597 12.9757Z"
            fill="#fff"
          />
        </g>
        <defs>
          <clipPath id="clip_diversity_banner">
            <rect width="16" height="16" fill="white" transform="translate(0.482422)" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="nxp-diversity-banner__body">
      <div class="nxp-diversity-banner__text-block">
        <h3 class="nxp-diversity-banner__title">
          Diversidade &amp; Inclusão
        </h3>
        <p v-if="!hasDiversity" class="nxp-diversity-banner__description">
          Insira suas informações de diversidade para vagas afirmativas. Seus dados são seguros e serão exibidos apenas a empresas comprometidas com diversidade e inclusão
        </p>
        <p v-else class="nxp-diversity-banner__description">
          Essas informações serão exibidas apenas em vagas afirmativas de empresas avaliadas e comprometidas com diversidade, e não serão usadas pela IA da Recrutei
        </p>
      </div>
      <button
        type="button"
        class="nxp-diversity-banner__link"
        @click="goToDiversity"
      >
        {{ hasDiversity ? "Editar informações de diversidade" : "Adicionar informações de diversidade" }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiversityBanner",
  data: () => ({
    value: {
      gender: { field: "Gênero", value: null },
      breed: { field: "Cor", value: null },
      deficiency: { field: "Deficiência(s)", value: null },
      isEgression: { field: "Pessoa egressa ou pré-egressa", value: null },
      isReability: {
        field: "Pessoa com deficiência reabilitada pelo INSS",
        value: null,
      },
    },
  }),
  computed: {
    hasDiversity() {
      return Object.keys(this.value)
        .filter((key) => key !== 'gender')
        .filter((key) => this.value[key] && this.value[key].value !== null)
        .length > 0;
    },
  },
  created() {
    this.fetchCandidateDataRequest();
  },
  watch: {
    '$route.name'() {
      // When returning from edit-diversity, refresh the summary.
      this.fetchCandidateDataRequest();
    },
  },
  methods: {
    goToDiversity() {
      const { params } = this.$router.history.current;
      this.$router.push({
        name: "edit-diversity",
        params,
      });
    },
    fetchCandidateDataRequest() {
      if (!this.$http) return;

      this.$vs.loading();

      // Reset values to avoid stale data.
      Object.keys(this.value).forEach((key) => {
        this.value[key].value = null;
      });

      this.$http
        .get("/api/v2/talents/profile/infos?from=diversity")
        .then((response) => {
          const { data } = response.data;

          if (data && data.length === 0) {
            this.$vs.loading.close();
            return;
          }

          if (data && data.gender_identity !== null) {
            if (data.gender_identity !== undefined) {
              this.value.gender.value = data.gender_identity.name;
            }
          }

          if (data && data.pcd_string !== null) {
            try {
              const listOfDeficiencies = JSON.parse(data.pcd_string);

              if (listOfDeficiencies.length > 2) {
                this.value.deficiency.value = listOfDeficiencies.join(", ");
              } else if (listOfDeficiencies.length === 2) {
                this.value.deficiency.value = listOfDeficiencies.join(" e ");
              } else if (listOfDeficiencies.length === 1) {
                this.value.deficiency.value = listOfDeficiencies[0];
              }
            } catch (error) {
              console.error(error);
            }
          }

          if (data && data.is_egression === true) {
            this.value.isEgression.value = "Sim";
          }

          if (data && data.pcd_reability === true) {
            this.value.isReability.value = "Sim";
          }

          if (data && data.breed !== null) {
            if (data.breed !== undefined) {
              this.value.breed.value = data.breed.name;
            }
          }

          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.nxp-diversity-banner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 16px;
  border: 0.5px solid #a8a8a8;
  background: #fff;
}

.nxp-diversity-banner__icon-wrap {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &--empty {
    background: rgba(48, 158, 58, 0.18);
  }

  &--filled {
    background: #309e3a;
  }
}

.nxp-diversity-banner__icon {
  display: block;
}

.nxp-diversity-banner__body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.nxp-diversity-banner__text-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.nxp-diversity-banner__title {
  margin: 0;
  width: 100%;
  color: #333;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
}

.nxp-diversity-banner__description {
  margin: 0;
  width: 100%;
  color: #696969;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}

.nxp-diversity-banner__link {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: #4f4f4f;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  text-decoration: underline;
  text-decoration-skip-ink: none;
}
</style>
